// TODO: Consider integrating this component into @crossnokaye/ux-common so it
// can be shared across all CK apps, not just Gaia.

import { AlertTriangle, CheckCircle, Info } from 'lucide-react';
import React from 'react';

import { Inline, Typography } from '@crossnokaye/ux-common';

type DialogAlertVariant = 'success' | 'caution' | 'info';

interface DialogAlertProps {
  variant: DialogAlertVariant;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

const variantStyles: Record<DialogAlertVariant, { container: string; text: string; icon: string }> =
  {
    success: {
      container: 'bg-ckds-text-fg-good/10 border-ckds-text-fg-good/30',
      text: 'text-ckds-text-fg-good',
      icon: 'text-ckds-text-fg-good',
    },
    caution: {
      container: 'bg-ckds-base-caution/10 border-ckds-base-caution/30',
      text: 'text-ckds-base-caution',
      icon: 'text-ckds-base-caution',
    },
    info: {
      container: 'bg-ckds-neutral-800 border-ckds-neutral-700',
      text: 'text-ckds-text-fg-tier2',
      icon: 'text-ckds-text-fg-tier2',
    },
  };

const defaultIcons: Record<DialogAlertVariant, React.ReactNode> = {
  success: <CheckCircle className="glyph glyph-sm" aria-hidden="true" />,
  caution: <AlertTriangle className="glyph glyph-sm" aria-hidden="true" />,
  info: <Info className="glyph glyph-sm" aria-hidden="true" />,
};

export const DialogAlert = ({ variant, children, icon }: DialogAlertProps): React.ReactElement => {
  const styles = variantStyles[variant];
  const renderedIcon = icon ?? defaultIcons[variant];

  return (
    <div
      className={`flex items-center gap-2 rounded-md border px-3 py-2 ${styles.container}`}
      data-component="DialogAlert"
    >
      <Inline gap="xs" className={`items-center ${styles.icon}`}>
        {renderedIcon}
      </Inline>
      <Typography variant="body" className={`text-sm ${styles.text}`}>
        {children}
      </Typography>
    </div>
  );
};
